import { Injectable } from '@angular/core';
import { LoDialogService } from 'lo-design-system';
import { CatalogPlan } from '@brand-lolly/app/billing/types/plan.types';
import { buildPlanDetailGroups } from '@brand-lolly/app/billing/plan-card/plan-card-rows.util';
import { PlanDetailsDialogComponent } from './plan-details-dialog.component';
import { PlanDetailsDialogData } from './plan-details-dialog.model';

/**
 * Opens the full "everything included" list for one plan.
 *
 * The plans pages each own a card's data already, so this takes the plan rather
 * than an id and builds the groups here — one place, so the pricing page and the
 * settings plans tab cannot show two different lists for the same plan.
 */
@Injectable({ providedIn: 'root' })
export class PlanDetailsDialogService {
	constructor(private dialogs: LoDialogService) {}

	/**
	 * `title` defaults to the catalogue's own per-rung name, but the plans pages
	 * pass the heading their CARD carries — the tier alone — so the dialog is
	 * named the same as the thing that opened it. The rung is stated beside it,
	 * not folded into it.
	 */
	open(plan: CatalogPlan, rungLabel = '', title = plan.title): void {
		this.dialogs.open<PlanDetailsDialogComponent, PlanDetailsDialogData>(
			PlanDetailsDialogComponent,
			{
				data: {
					planTitle: title,
					rungLabel,
					groups: buildPlanDetailGroups(plan)
				}
			}
		);
	}
}
